module.exports = __webpack_public_path__ + "static/media/bi.4abf260a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bi.png
// module id = 1798
// module chunks = 0